import { render, staticRenderFns } from "./CurePlans.vue?vue&type=template&id=3703e754&"
import script from "./CurePlans.vue?vue&type=script&lang=js&"
export * from "./CurePlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports